export const TOGGLE_MODAL = "TOGGLE_MODAL";


export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN"
export const REMOVE_AUTH_TOKEN = "REMOVE_AUTH_TOKEN"

export const SET_USER_ROLE = "SET_USER_ROLE"
export const REMOVE_USER_ROLE = "REMOVE_USER_ROLE"




export const SET_LOGGED_USER = "SET_LOGGED_USER"
export const DELETE_LOGGED_USER = "DELETE_LOGGED_USER"

export const SET_SELECTED_LEVEL = "SET_SELECTED_LEVEL"
export const SET_SELECTED_GAME = "SET_SELECTED_GAME"

//Trial Games Actions
